'use strict';

angular.module('membership')
  .service('ownershipViewModel', [
    'membership.config', '$state', 'modalDialogService', 'Customer', /*'Status',*/
    function (config, $state, modalDialogService, Customer/*, Status*/) {

      var viewModel = function () {

        var self = this;

        self.filterOpen = false;
        self.filter = {};
        //self.customersStatuses = {};

        self.datatablesConfig = {
          datasourceUrl: config.apiUrls.base + '/ownership/datasource',
          dtColumns: [
            {
              "bSearchable": false,
              "bVisible": false,
              "aTargets": [0]
            },
            {
              aTargets: [1],
              "sClass": "dynamic-html no-wrap",
              render: function (data, type, full, meta) {
                if (full[5] === 'True') {
                  return "<span>" + full[1] + "</span>";
                }

                return "<a ui-sref='membership_customer.general({key: " + full[0] + "})' >" + full[1] + "</a>";
              }
            },
            {
              aTargets: [2],
              "sClass": "dynamic-html no-wrap",
              render: function (data, type, full, meta) {
                if (full[5] === 'True') {
                  return "<span>" + full[2] + "</span>";
                }

                return "<a ui-sref='membership_customer.general({key: " + full[0] + "})' >" + full[2] + "</a>";
              }
            },
            {
              aTargets: [3],
              "sClass": "dynamic-html no-wrap",
              render: function (data, type, full, meta) {
                if (full[5] === 'True') {
                  return "<span>" + full[3] + "</span>";
                }

                return "<a ui-sref='membership_customer.general({key: " + full[0] + "})' >" + full[3] + "</a>";
              }
            },
            {
              aTargets: [4],
              "sClass": "dynamic-html no-wrap",
              render: function (data, type, full, meta) {
                if (full[5] === 'True') {
                  return "<span>" + full[4] + "</span>";
                }

                return "<a ui-sref='membership_customer.general({key: " + full[0] + "})' >" + full[4] + "</a>";
              }
            },
            {
              aTargets: [5],
              "sClass": "dynamic-html no-wrap",
              render: function (data, type, full, meta) {
                if (full[5] === 'True') {
                  return "<span>" + full[5] + "</span>";
                }

                return "<a ui-sref='membership_customer.general({key: " + full[0] + "})' >" + full[5] + "</a>";
              }
            },
            
            {
              "aTargets": -1,
              "bSearchable": false,
              "bSortable": false,
              "data": null,
              "sWidth": 50,
              "sClass": "actions-col dynamic-html no-wrap",
              /*"render": function (data, type, full, meta) {

                var buttons = [  
                    editBtn              
                ];

                if (data[5] === 'True') {
                  buttons.push("<a class='btn btn-info' ng-click='model.revertCustomer(" + data[0] + ")' title='Restore' ><i class='fa fa-undo'></i></a>")
                }
                if (data[6] === 'True'){
                  buttons.push(editBtn)
                }

                return buttons.join('&nbsp;');
              }, */
             "render": function (data, type, full, meta) {
                var editBtn = "<a class='btn btn-success' ng-click='model.modifyOwnership(" + full[0] + ", " + "\""+ full[1] + "\""+ ")' title='Modify' ><i class='fa fa-cog'></i></a>";                
                return editBtn;
             }
            }
          ],
          customFilter: self.filter,
          /*fnDrawCallback: function(settings) {
            var customers = _.map(settings.json.data, function(r){ return parseInt(r[0]); });

            Status.getStatuses(customers).then(function(resp){
              console.log(resp);
              self.customersStatuses = resp;
            });
          },*/
          dom: "<'row'<'col-xs-12 col-sm-12'r>>" +
          "t" +
          "<'row'<'col-sm-2 col-xs-12 hidden-xs'l><'col-sm-4 col-xs-12 hidden-xs'<'pull-right'i>><'col-xs-12 col-sm-6'p>>"

        };

        /*self.getCustomerStatusLabel = function(id) {
          return self.customersStatuses[id.toString()] || 'N/A';
        }*/

        /*self.getCustomerStatusCssClass = function(id) {
          var status = self.customersStatuses[id.toString()];
          if (!status) {
            return 'status-na';
          }

          return status == 'Error' ? 'btn-danger' : 'btn-success';
        }*/
        self.createCustomer = function () {
          modalDialogService
            .showWindow('components/membership/customer/newCustomerDialog/newCustomerDialog.tpl.html', 'NewCustomerCtrl');
        };

        self.revertCustomer = function (id) {
           modalDialogService.showConfirmation('Are you sure you want to revert this customer?', 'Customers Module')
            .then(function(res) {
              if (res) {
                Customer.revertCustomer(id).then(function() {
                  self.datatablesConfig.reload();
                });  
              }
            });
        };
        self.modifyOwnership = function(id, name) {
          modalDialogService
            .showWindow('components/membership/customer/modifyOwnership/modifyOwnership.html', 'ModifyAgentCtrl', {$$selectedId : id, $$selectedName : name, $$ownershipvm : self});
        };
        self.createOwnership = function(id, name) {
          modalDialogService
            .showWindow('components/membership/customer/modifyOwnership/createOwnership.html', 'ModifyAgentCtrl', {$$selectedId : id, $$selectedName : name, $$ownershipvm : self});
        };

      };


      return viewModel;

    }
  ]);
